import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Battery = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text49']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text50']),
          }}
        ></h5>
        <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text51']),
          }}
        ></h6>
      </div>

      <div className={styles.paramsBox}>
        <div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text52']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text53']),
              }}
              className="mainText"
            ></h3>
          </div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text54']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text55']),
              }}
              className="mainText"
            ></h3>
          </div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text56']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text57']),
              }}
              className="mainText"
            ></h3>
          </div>
        </div>

        <img
          src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-battery.jpg"
          alt=""
        />
      </div>
    </div>
  );
};

export default Battery;
